import {RequestStatus} from '../../shared/variables'

export enum DealerSelectionStatus {
    LOADING = 'loading',
    READY = 'ready',
    UNAVAILABLE = 'unavailable',
}

export interface DealerSelectionData {
    provincesStatus: RequestStatus
    dealersStatus: RequestStatus
    hasProvinces: boolean
    hasDealers: boolean
}

/**
 * Tells whether the province and dealer selects of the quotation form can be
 * shown: both lists are needed to pick a dealer, so the selection is
 * unavailable when either request fails or comes back empty.
 *
 * @param data Status of the two requests and whether their lists have items
 * @returns The status of the dealer selection
 */
export function getDealerSelectionStatus({
    provincesStatus,
    dealersStatus,
    hasProvinces,
    hasDealers,
}: DealerSelectionData): DealerSelectionStatus {
    if (hasProvinces && hasDealers) {
        return DealerSelectionStatus.READY
    }

    const statuses = [provincesStatus, dealersStatus]

    if (
        statuses.includes(RequestStatus.FAILED) ||
        statuses.every((status) => status === RequestStatus.SUCCEEDED)
    ) {
        return DealerSelectionStatus.UNAVAILABLE
    }

    return DealerSelectionStatus.LOADING
}
